// extracted by mini-css-extract-plugin
export default {"pageHolder":"Support_pageHolder__DP+Ss","imageHolder":"Support_imageHolder__zC5df","newChatBtn":"Support_newChatBtn__pdwdO"};